import styled from "styled-components";
import { px2rem } from "common/helpers/rem";
const linkPreviewHeight = px2rem(112);

export const Container = styled.a`
  display: block;
  text-decoration: none;
  background-color: ${props => props.theme.white100};
`;

export const ContentContainer = styled.div`
  border: solid ${px2rem(1)} ${props => props.theme.grey300};
  border-radius: ${px2rem(8)};
  display: flex;
  height: ${linkPreviewHeight};
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${px2rem(8)};
`;
export const Title = styled.h2`
  color: ${props => props.theme.grey1000};
  margin: 0;
  font-size: ${px2rem(13)};
  line-height: ${px2rem(18)};
  margin-bottom: ${px2rem(4)};
`;
export const Description = styled.div`
  font-size: ${px2rem(12)};
  line-height: ${px2rem(18)};
  color: ${props => props.theme.grey800};
  margin: 0;
  flex: 1;
`;
export const Url = styled.div`
  font-size: ${px2rem(11)};
  line-height: ${px2rem(16)};
  color: ${props => props.theme.grey700};
  display: flex;
  align-items: center;

  svg {
    margin-left: ${px2rem(4)};
  }
`;
export const Image = styled.div`
  flex: 1;
  max-width: ${linkPreviewHeight};
  background-position: center;
  background-size: cover;
  border-bottom-right-radius: ${px2rem(6)};
  border-top-right-radius: ${px2rem(6)};
`;
